// extracted by mini-css-extract-plugin
module.exports = {"auth":"GeneralAuth_auth__2aMJy","error":"GeneralAuth_error__aW12U","auth__Form__OR":"GeneralAuth_auth__Form__OR__KF4RV"};